import Typography from "@mui/material/Typography";
import { UserManagement } from "@myplant-io/user-management";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  header: {
    id: "user.header",
    defaultMessage: "User Management",
  },
});

export function UserManagementPage() {
  const { formatMessage: t } = useIntl();

  return (
    <>
      <div className="p-4 sm:px-6 py-4">
        <Typography variant="h4">{t(messages.header)}</Typography>
      </div>
      <div className="flex flex-col flex-grow overflow-hidden p-4 sm:px-6 py-4">
        <UserManagement
          apiBaseUrl="/seshat"
          wsBaseUrl="/ws"
          showImpersonationAction
        />
      </div>
    </>
  );
}
